// extracted by mini-css-extract-plugin
export default {"wrapper":"TextArea_wrapper__gFuyF"};